export enum QuestionType {
  LONG_TEXT = "long_text",
  YES_NO = "yes_no",
  CHECKBOX_MULTI = "checkbox_multi",
  RADIO_GROUP = "radio_group",
  DATE = "date",
  FILE_SINGLE = "file_single",
  ADDRESS = "address"
}

type BaseSurveyTemplateQuestion = {
  id: number;
  internal_id: string;
  index: number;
  question: string;
  description: string;
  is_required: boolean;
};

export type SurveyQuestionOptionsConfig = BaseSurveyTemplateQuestion & {
  type:
    | QuestionType.YES_NO
    | QuestionType.CHECKBOX_MULTI
    | QuestionType.RADIO_GROUP;
  options: [string, ...string[]];
};

export type SurveyQuestionLongTextConfig = BaseSurveyTemplateQuestion & {
  type: QuestionType.LONG_TEXT;
  options?: never;
};

export type SurveyQuestionDateConfig = BaseSurveyTemplateQuestion & {
  type: QuestionType.DATE;
  options?: never;
};

export type SurveyQuestionFileConfig = BaseSurveyTemplateQuestion & {
  type: QuestionType.FILE_SINGLE;
  options?: never;
};

export type SurveyQuestionAddressConfig = BaseSurveyTemplateQuestion & {
  type: QuestionType.ADDRESS;
  options?: never;
};

export type SurveyTemplateQuestion =
  | SurveyQuestionOptionsConfig
  | SurveyQuestionLongTextConfig
  | SurveyQuestionDateConfig
  | SurveyQuestionFileConfig
  | SurveyQuestionAddressConfig;

export type SurveyTemplateCondition = {
  id: number;
  parent_question_internal_id: string;
  child_question_internal_ids: string[];
  action: string;
  condition: Record<string, unknown>;
};
